<div class="app-modal-container" [attr.data-automation-id]="'bc-modal'">
  <div class="app-modal-header">
    <h3 class="app-modal-title" mat-dialog-title>
      <gux-icon *ngIf="data.icon"
            [attr.icon-name]="data.icon"
            slot="icon"
            [ngClass]="data.iconClass"
            decorative>
      </gux-icon>
      {{ data.headerText | translate }}
    </h3>
    <button class="icon-close" [attr.data-automation-id]="'bc-modal-close-icon'" mat-dialog-close *ngIf="data.closeable">
      <svg-icon icon="x"></svg-icon>
    </button>
  </div>
  <div class="app-modal-body" mat-dialog-content>
    <div class="app-modal-message" [attr.data-automation-id]="'bc-modal-message'">
      {{ data.messageBody | translate }}
    </div>
    <div *ngIf="data.doNotShowAgainById" class="app-modal-do-not-show-again">
      <mat-checkbox [attr.data-automation-id]="'bc-modal-checkbox'" (change)="doNotShowChanged($event, data.doNotShowAgainById)">{{ 'modalDialog.doNotShowAgain' | translate }}</mat-checkbox>
    </div>
    <div class="app-modal-note" [attr.data-automation-id]="'bc-modal-note'" *ngIf="data.messageNote" [innerHTML]="data.messageNote | translate"></div>
  </div>
  <div class="app-modal-footer" mat-dialog-actions>
    <button *ngIf="data.confirmButton.text" class="btn btn-dark" cdkFocusInitial
            [mat-dialog-close]="true" [attr.data-automation-id]="'bc-modal-ok'">
      <span>{{ data.confirmButton.text | translate }}</span>
    </button>
    <button *ngIf="data.cancelButton.text" class="btn btn-light" mat-dialog-close [attr.data-automation-id]="'bc-modal-close'">
      <span>{{ data.cancelButton.text | translate }}</span>
    </button>
  </div>
</div>
